import { render, staticRenderFns } from "./PortalPopup.vue?vue&type=template&id=3c34cc64&"
import script from "./PortalPopup.vue?vue&type=script&lang=js&"
export * from "./PortalPopup.vue?vue&type=script&lang=js&"
import style0 from "./PortalPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports